<template>
  <div class="mail__mail-item sm:px-4 px-2 py-6" :class="{'mail__opened-mail': unRead}">

    <!-- MAIL ROW 1 : META -->
    <div class="flex w-full">
      <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
                 :src="userPhoto" size="40px"></vs-avatar>

      <div class="flex w-full justify-between items-start">
        <div class="mail__details">
          <h5 class="mb-1" :class="{'font-semibold': unRead}">{{ userName }} {{ courseName }}</h5>
          <span v-if="mail.topic">{{ mail.topic }}</span>
          <span v-else>{{ $t('pm.no-subject') }}</span>
        </div>

        <div class="mail-item__meta flex items-center">
          <!--<div class="email__labels sm:flex items-center" v-if="unRead">
            <div class="h-2 w-2 rounded-full mr-2 bg-primary"></div>
          </div>-->
          <div class="flex flex-col justify-end">
            <span class="text-right">{{ mail.updatedAt | time }}</span>
            <div class="flex justify-end mt-1">
              <span class="text-right">{{ mail.updatedAt | date(true) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /MAIL ROW 1 -->

    <!-- MAIL ROW 2 : MSG & ACTIONS -->
    <div class="flex w-full">
      <div class="flex items-center ml-1">
        <div></div>
<!--        <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox>-->
<!--        <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning fill-current stroke-current': mail.isStarred}, 'w-5', 'h-5']" @click.stop="toggleIsStarred"></feather-icon>-->
      </div>
      <div class="mail__message truncate ml-3">
        <div class="mail-item__meta flex items-center">
          <div class="email__labels sm:flex items-center" v-if="unRead">
            <div class="h-2 w-2 rounded-full mr-2 bg-primary"></div>
          </div>
          <span v-html="lastMessage"></span>
        </div>
      </div>
    </div>
    <!-- /MAIL ROW 2 -->
  </div>
</template>

<script>
  import { getAvatarUrl } from "../../../../utils/upload";

  export default {
    props: [
      'mail',
      'isSelected',
      'currentUser',
    ],
    data() {
      return {
        isSelectedMail: this.isSelected,
      }
    },
    watch: {
      isSelected(value) {
        this.isSelectedMail = value
      },
      isSelectedMail(val) {
        val ? this.$emit('addToSelected', this.mail.id) : this.$emit('removeSelected', this.mail.id)
      }
    },
    computed: {
      labelColor() {
        return (label) => {
          const tags = this.$store.state.email.mailTags
          return tags.find((tag) => {
            return tag.value === label
          }).color
        }
      },
      userPhoto(){
        if(this.mail){
          if(this.mail.privateMessageReplies && this.mail.privateMessageReplies.length > 0){
            const lastPosition = this.mail.privateMessageReplies.length - 1;
            return getAvatarUrl(this.mail.privateMessageReplies[lastPosition].fromUser.photo)
          }else{
            return getAvatarUrl(this.mail.fromUser.photo)
          }
        }
        return ''
      },
      userName(){
        if(this.mail){
          if(this.mail.privateMessageReplies && this.mail.privateMessageReplies.length > 0){
            const lastPosition = this.mail.privateMessageReplies.length - 1;
            const lastMessage = this.mail.privateMessageReplies[lastPosition];
            return `${lastMessage.fromUser.code} ${lastMessage.fromUser.nameLocal} ${lastMessage.fromUser.surnameLocal}`
          }else{
            return `${this.mail.fromUser.code} ${this.mail.fromUser.nameLocal} ${this.mail.fromUser.surnameLocal}`
          }
        }
        return '';
      },
      courseName(){
        if(this.mail){
          return `${this.mail.courseOutlineRegistration.subjectCode} ${this.$t('pm.section-no')} ${this.mail.classSection.sectionNo}`
        }
        return ''
      },
      lastMessage(){
        if(this.mail){
          if(this.mail.privateMessageReplies && this.mail.privateMessageReplies.length > 0){
            const lastPosition = this.mail.privateMessageReplies.length - 1;
            return this.mail.privateMessageReplies[lastPosition].message
          }else{
            return this.mail.message;
          }
        }
        return '';
      },
      unRead(){
        if(this.mail && this.currentUser){
          if(this.currentUser.id === this.mail.toUser.id &&
             this.currentUser.id !== this.mail.updatedBy.id){
            // if send to this user check hasNewReply
            if(this.mail.hasNewReply || !this.mail.readDate){
              return true
            }
          }else{
            //if sent from this user check isRead in reply
            const unRead = this.mail.privateMessageReplies.filter(item => {
              return this.currentUser.id === item.toUser.id && !item.isRead
            });
            if(unRead && unRead.length > 0){
              return true;
            }
          }
        }
        return false;
      }
    },
    methods: {
      toggleIsStarred() {
        const payload = { mailId: this.mail.id, value: !this.mail.isStarred }
        this.$store.dispatch('email/toggleIsMailStarred', payload)
      }
    }
  }

</script>

